import { Row, Col, Container, Button } from 'react-bootstrap'
import Image from 'next/image'
import Link from 'next/link'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { ChevronDown, Star, Tick } from 'assets/icons/components'

const Img = styled.img`
  width: 30px;
  margin-right: 10px;
  height: initial !important;
`

const Text = styled.span`
  padding-right: 10px;
  vertical-align: middle;
  font-size: 13px;
  font-weight: 600;
  color: var(--gray);
`

const LocalesContainer = styled.div`
  position: absolute;
  background: #FFF;
  z-index: 30;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 2px #a0a0a0;
  top: 26px;
  width: 130px;
  padding: 6px 0px;
  display: none;
`
const Wrapper = styled.div`
  cursor: pointer;
  display: inline-block;
  margin-left: 15px;
  position: relative;
  &:hover ${LocalesContainer} {
    display: block;
  }
  svg {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }
`

const LocaleItem = styled.a`
  cursor: pointer;
  display: inline-block;
  margin-bottom: 5px;
  padding-left: 10px;
  text-align: left;
  width: 100%;
  color: #414141;
  &:hover, &.active {
    color: #f84f7f;
    background: #f0f0f0;
  }
`

const LocaleImage = styled.img`
  width: 26px;
  vertical-align: middle;
  height: initial !important;
`

const LocaleItemLabel = styled.span`
  font-weight: 600;
  font-size: 0.8rem;
  margin-left: 10px;
`

const StarContainer = styled.span`
  color: #f84f7f;
  display: inline-block;
  padding-left: 5px;
  padding-right: 10px;
  vertical-align: text-bottom;
  svg {
    height: 1em;
  }
`

const VerifiedIcon = styled.span`
  color: #f84f7f;
  border: 2px solid #f84f7f;
  border-radius: 50%;
  display: inline-block;
  padding: 1px 4px;
  font-size: 12px;
  margin-right: 5px;
`

const VerifiedCompany = styled.div`
  text-align: center;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    height: 1em;
  }
`

const DownloadImg = styled.img`
  transition: .3s;
  &:hover {
    transform: scale(1.05);
  }
`

const Intro = (props) => {
  const { t, query } = props

  const router = useRouter()

  const [locale, setLocale] = useState(router?.locale || 'en')
  const [locales, setLocales] = useState([
    { code: 'ru', label: 'Pусский' },
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'fr', label: 'Français' },
    { code: 'ko', label: '한국인'},
    { code: 'ja', label: '日本語' },
    { code: 'sv', label: 'Svenska' },
    { code: 'da', label: 'Dansk'},
    { code: 'de', label: 'Deutsch' },
    { code: 'fi', label: 'Suomi' },
    { code: 'no', label: 'Norsk'},
    { code: 'it', label: 'Italiano' },
    { code: 'pt', label: 'Português' },
    { code: 'tr', label: 'Türkçe'},
    { code: 'nl', label: 'Nederlands' },
    { code: 'pl', label: 'Polski' },
    { code: 'zh', label: '中文(简体)'},
    { code: 'cs', label: 'Čeština' },
    { code: 'ro', label: 'Română'}
  ])


  return (
    <div className='hero-container'>
      <div className='hero-container__logo'>
        <Link href='/'>
          <a >
            <Image
              loader={({ src }) => `https://flirtbees.com/images/${src}`}
              alt="Logo image"
              src="logo.png" 
              width = '237px'
              height= '60px'
              loading = 'eager'
            />
          </a>
        </Link>
        <Wrapper>
          <Text>{ locales.find(i => i.code === locale)?.label }</Text>
          <Img src={`/images/flags/${locale || 'en'}.png`} alt={t('Language')} width={30} height={20} />
          <ChevronDown />
          <LocalesContainer>
            { locales.map(locale => (
              <LocaleItem key={locale.code}
                href={`/${locale.code}` + (router.pathname !== '/' ? router.pathname : '' )}>
                <LocaleImage src={`/images/flags/${locale.code}.png`} />
                <LocaleItemLabel>{ locale.label }</LocaleItemLabel>
              </LocaleItem>
            ))} 
          </LocalesContainer>
        </Wrapper>
      </div>
      <Container >
        <Row>
          <Col
            xl={{ span: 6, order: 'first' }}
            lg={{ span: 6, order: 'first' }}
            md={{ span: 12, order: 'first' }}
            xs={{ span: 12, order: 'first' }}>
            <div className='hero-container__text'>
              <h1 className='hero-container__text-name'>
                {t('intro1.h1')}
              </h1>
              <section>
                <h2>
                </h2>
                <h3 className='hero-container__text-description'>
                  {t('intro1.h3')}
                </h3 >
              </section>
              
              <div className='hero-container__text-sub-description'>
                <p>{t('intro1.p1')}</p>
                <p>{t('intro1.p2')}</p>
              </div>
              <Link href={{ pathname: '/trial', query: query, shallow: true }}>
                <a className='button__free-trial btn btn-primary'>
                  {t('free-trial')}
                </a>
              </Link>
              <div className="mobile-section" style={{ marginBottom: '20px' }}>
                <h4>{t('NO SIGN UP NEEDED')}</h4>
                <a className="ios"  href="https://apps.apple.com/us/app/flirtbees/id1520859706" target="_blank">
                  <DownloadImg src="/images/download-iphone-app.svg" alt="Apple store" width={168} height={56}/>
                </a>
                <a className="android"  href="https://play.google.com/store/apps/details?id=com.app.flirtbees" target="_blank">
                  <DownloadImg src="/images/download-android-app.svg" alt="CH Play store" width={168} height={50}/>
                </a>
              </div>
            </div>
          </Col>
          <Col
            xl={{ span: 6, order: 'last' }}
            lg={{ span: 6, order: 'last' }}
            md={{ span: 12, order: 'last' }}
            xs={{ span: 12, order: 'last' }}>
            <Image
              loader={({ src }) => `https://flirtbees.com/images/${src}`}
              src='hero_1.jpg'
              alt="Hero image"
              className='hero-container__image' 
              width = '545px'
              height= '287px'
              quality={100}
              loading = 'eager'
            />
              <Row>
                <Col
                  style={{ marginTop: '30px', textAlign: 'center' }}
                  xs={{ span: 12 }}>
                    <strong>4.6</strong>
                    <StarContainer>
                      <Star />
                      <Star />
                      <Star />
                      <Star />
                      <Star />
                    </StarContainer>
                    {t('TrustScore based on 416 reviews')}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={{ span: 12 }}>
                    <VerifiedCompany>
                      <VerifiedIcon><Tick /></VerifiedIcon> {t('Verified company')}
                    </VerifiedCompany>
                </Col>
              </Row>
            
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Intro
